/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Details about the program using the conflicting index, present if isAvailable is false.
 * @export
 * @interface ProgramIndexAvailabilityResponseConflictingProgramInfo
 */
export interface ProgramIndexAvailabilityResponseConflictingProgramInfo {
    /**
     * ID of the existing program using the conflicting index.
     * @type {string}
     * @memberof ProgramIndexAvailabilityResponseConflictingProgramInfo
     */
    programId?: string;
    /**
     * Name of the existing program.
     * @type {string}
     * @memberof ProgramIndexAvailabilityResponseConflictingProgramInfo
     */
    programName?: string;
    /**
     * The conflicting program index.
     * @type {number}
     * @memberof ProgramIndexAvailabilityResponseConflictingProgramInfo
     */
    programIndex?: number;
}

/**
 * Check if a given object implements the ProgramIndexAvailabilityResponseConflictingProgramInfo interface.
 */
export function instanceOfProgramIndexAvailabilityResponseConflictingProgramInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProgramIndexAvailabilityResponseConflictingProgramInfoFromJSON(json: any): ProgramIndexAvailabilityResponseConflictingProgramInfo {
    return ProgramIndexAvailabilityResponseConflictingProgramInfoFromJSONTyped(json, false);
}

export function ProgramIndexAvailabilityResponseConflictingProgramInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramIndexAvailabilityResponseConflictingProgramInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programId': !exists(json, 'programId') ? undefined : json['programId'],
        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'programIndex': !exists(json, 'programIndex') ? undefined : json['programIndex'],
    };
}

export function ProgramIndexAvailabilityResponseConflictingProgramInfoToJSON(value?: ProgramIndexAvailabilityResponseConflictingProgramInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programId': value.programId,
        'programName': value.programName,
        'programIndex': value.programIndex,
    };
}

